import { FC } from "react";
import { ContentfulComponentType } from "./types";
import { ContentfulArticleList } from "./ContentfulArticleList/ArticleList";
import { ContentfulComponent } from "./ContentfulComponent";
import { ContentfulFaq } from "./ContentfulFaq";
import { ContentfulHero } from "./ContentfulHero";
import { ContentfulTextAndMedia } from "./ContentfulTextAndMedia";
import { ContentfulRichText } from "./ContentfulRichText";
import { ContentfulC2A } from "./ContentfulC2A";
import { ContentfulTextAndListV2 } from "./ContentfulTextAndListV2/ContentfulTextAndListV2";
import { ContentfulCards } from "./ContentfulCards";
import { ContentfulBenefitsV2 } from "./ContentfulBenefitsV2";
import { ContentfulTextAndText } from "./ContentfulTextAndText";
import { ContentfulStructuredData } from "./ContentfulStructuredData";
import { ContentfulTextAndMediaCarousel } from "./ContentfulTextAndMediaCarousel/ContentfulTextAndMediaCarousel";
import { ContentfulPackagesV2 } from "./ContentfulPackagesV2";
import { ContentfulPromoBanner } from "./ContentfulPromoBanner";
import { ContentfulVariantContainer } from "./ContentfulVariantContainer";

export enum ComponentTypeNames {
  Component = "Component",
  FaqBlock = "ComponentFaq",
  Cards = "ComponentCards",
  Hero = "ComponentHero",
  Benefits = "ComponentBenefits",
  Packages = "ComponentPackages",
  TextAndList = "ComponentTextAndList",
  TextAndMedia = "ComponentTextAndMedia",
  TextAndText = "ComponentTextAndText",
  ArticleList = "ComponentArticleList",
  RichText = "ComponentRichText",
  C2A = "ComponentC2A",
  StructuredData = "ComponentStructuredData",
  TextAndMediaCarousel = "ComponentTextAndMediaCarousel",
  PromoBanner = "ComponentPromoBanner",
  // Amplitude Experiment wrapper: holds one variant per experiment arm.
  VariantContainer = "VariantContainer",
}

export const ComponentMap: Record<
  string,
  ContentfulComponentType<any> | FC<any>
> = {
  [ComponentTypeNames.FaqBlock]: ContentfulFaq,
  [ComponentTypeNames.Component]: ContentfulComponent,
  [ComponentTypeNames.Cards]: ContentfulCards,
  [ComponentTypeNames.Hero]: ContentfulHero,
  [ComponentTypeNames.Benefits]: ContentfulBenefitsV2,
  [ComponentTypeNames.TextAndList]: ContentfulTextAndListV2,
  [ComponentTypeNames.TextAndMedia]: ContentfulTextAndMedia,
  [ComponentTypeNames.TextAndText]: ContentfulTextAndText,
  [ComponentTypeNames.Packages]: ContentfulPackagesV2,
  [ComponentTypeNames.ArticleList]: ContentfulArticleList,
  [ComponentTypeNames.RichText]: ContentfulRichText,
  [ComponentTypeNames.C2A]: ContentfulC2A,
  [ComponentTypeNames.StructuredData]: ContentfulStructuredData,
  [ComponentTypeNames.TextAndMediaCarousel]: ContentfulTextAndMediaCarousel,
  [ComponentTypeNames.PromoBanner]: ContentfulPromoBanner,
  [ComponentTypeNames.VariantContainer]: ContentfulVariantContainer,
};

export const RichTextMap: Record<
  string,
  ContentfulComponentType<any> | FC<any>
> = {
  [ComponentTypeNames.Component]: ContentfulComponent,
};
